var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReportFlag = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 13,
  height: 13,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#report_flag_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "m9.354 4.638.005.008c.099.156.233.376.379.63.285.502.629 1.168.804 1.76a.965.965 0 0 1-.193.917c-.196.23-.486.367-.79.397-.132.012-.266.026-.402.04-.844.083-1.741.172-2.66.172-.918 0-1.814-.089-2.656-.173l-.224-.022v3.437a.643.643 0 0 1-1.286 0v-4.5c0-.042.004-.083.012-.123a1.307 1.307 0 0 1-.005-.114v-4.77a1.3 1.3 0 0 1 1.177-1.291l.326-.032C4.683.89 5.579.8 6.498.8c.918 0 1.815.09 2.659.173l.403.04c.303.029.593.166.79.397a.96.96 0 0 1 .189.918c-.178.581-.522 1.225-.808 1.706-.144.244-.279.454-.377.603Z",
  fill: "#3A434A"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "report_flag_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(.5 .5)",
  d: "M0 0h12v12H0z"
})))));
export default SvgReportFlag;